export function loadStoredValue<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  try {
    const stored = localStorage.getItem(key);
    return (allowed as readonly string[]).includes(stored ?? "") ? (stored as T) : fallback;
  } catch {
    return fallback;
  }
}

export function storeValue(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // ignore storage failures (e.g. private browsing)
  }
}
